export default __webpack_public_path__ + "static/media/RedMarker.fde7ce63.png";